import React from 'react';
import { useTranslation } from 'react-i18next';
import { PermissionEnum, PermissionGuardEmbedTypeEnum } from '../enums/PermissionEnum';
import { usePermissions } from '../hooks/usePermissions';
import { BaseLayout } from '../layouts/BaseLayout';
import { XOctagonFill } from 'react-bootstrap-icons';
import { Flex } from 'antd';

interface PermissionGuardProps {
  permission: PermissionEnum | PermissionEnum[];
  fallback?: React.ReactNode;
  children: React.ReactNode;
  embedType?: PermissionGuardEmbedTypeEnum;
}

const PermissionGuard: React.FC<PermissionGuardProps> = ({
  permission,
  fallback,
  children,
  embedType = PermissionGuardEmbedTypeEnum.SECTION,
}) => {
  const { hasPermission } = usePermissions();
  const { t } = useTranslation('common');

  if (hasPermission(permission)) {
    return <>{children}</>;
  }

  return fallback ? (
    fallback
  ) : embedType === PermissionGuardEmbedTypeEnum.COMPONENT ? (
    <></>
  ) : (
    <BaseLayout
      pageTitle={''}
      content={
        <div className="w-full bg-white">
          <Flex align="center" className="ml-12">
            <XOctagonFill className="text-xl text-primary-red"></XOctagonFill>
            <span className="ml-2 font-medium">{t('unauthorized')}</span>
          </Flex>
        </div>
      }
    ></BaseLayout>
  );
};

export default PermissionGuard;
